/* Duvenest PDP optim — dynamic delivery-date + order-cutoff urgency.
   Niche-agnostic: reads config from data-* on .msb__deliv if present, else defaults.
   CUTOFF_HOUR = local dispatch cutoff in Europe/Berlin (supplier TZ).
   SHIP_DAYS   = upper bound of the existing "5-6 days" window (never over-promises).
   Renders e.g.:  ● Get it by Mon, Jul 7 — order within 4h 12m
   Pure display of the existing shipping promise as a concrete date; no price/offer logic. */
(function () {
  var CUTOFF_HOUR = 15;   // 15:00 Europe/Berlin
  var SHIP_DAYS   = 6;    // conservative end of the store's stated 5–6 day window

  function berlinNow() {
    // Current wall-clock in Europe/Berlin, as a Date built from its parts (so getDay/hours are Berlin-local).
    var s = new Date().toLocaleString('en-US', { timeZone: 'Europe/Berlin' });
    return new Date(s);
  }
  function fmt(d) {
    return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  }
  function two(n) { return (n < 10 ? '0' : '') + n; }

  function compute() {
    var now = berlinNow();
    var order = new Date(now);
    // If past today's cutoff, dispatch starts tomorrow.
    if (now.getHours() >= CUTOFF_HOUR) order.setDate(order.getDate() + 1);
    var arrive = new Date(order);
    arrive.setDate(arrive.getDate() + SHIP_DAYS);
    // Couriers rarely deliver Sunday → push to Monday.
    if (arrive.getDay() === 0) arrive.setDate(arrive.getDate() + 1);

    // Countdown to today's cutoff (only meaningful before cutoff).
    var msLeft = 0;
    if (now.getHours() < CUTOFF_HOUR) {
      var cut = new Date(now);
      cut.setHours(CUTOFF_HOUR, 0, 0, 0);
      msLeft = cut - now;
    }
    return { arrive: arrive, msLeft: msLeft };
  }

  function render() {
    // Write only into the dedicated text span so the sibling dot (<b>) and its
    // green-circle CSS are never touched. Countdown uses <span>, not <b>.
    var els = document.querySelectorAll('.msb__deliv-t, .atl-deliv-t');
    if (!els.length) return;
    var r = compute();
    var urgency = '';
    if (r.msLeft > 0) {
      var h = Math.floor(r.msLeft / 3600000);
      var m = Math.floor((r.msLeft % 3600000) / 60000);
      urgency = ' — order within <span class="msb__cut">' + h + 'h ' + two(m) + 'm</span>';
    }
    var html = 'Get it by <strong>' + fmt(r.arrive) + '</strong>' + urgency;
    els.forEach(function (el) { el.innerHTML = html; });
  }

  function boot() {
    render();
    // Tick the countdown minute-by-minute.
    setInterval(render, 60000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
